import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { device } from '../device';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faLocationPin, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {useHistory} from 'react-router-dom';
import { useParams } from 'react-router';
import { marked } from 'marked';
import { useTheme } from '@mui/material/styles';

const Section = styled(Box)(({theme, input_color}) => `
    background-color: ${input_color ? input_color.hex : theme.palette.black.o_eightyseven};
    padding: 32px 16px;
`);

const ContentBox = styled(Box)(({theme}) => `
    align-self: stretch;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    gap: 120px;
    max-width: 1200px;
`);

const DividerRec = styled(Box)(({theme}) => `
    background-color: ${theme.palette.grey.darken_3};
    display: flex;
    height: 2px;
    min-width: 100%;
`);

const MainBox = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 120px;
    align-self: stretch;
    @media ${device.tablet} {
        flex-direction: row;
        gap: 72px;
    }
`);

const CopyrightBox = styled(Box)(({theme}) => `
    display: flex;
    justify-content: start;
    align-items: start;
    align-self: stretch;
`);

const Col1Box = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 120px;
    align-self: stretch;
    @media ${device.laptop} {
        display: flex;
        flex-direction: row;
        gap: 72px;
        align-self: stretch;
        flex: 1 0 0;
    }
`);

const ContactBox = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
`);

const CompanyAndDescriptionBox = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    flex: 1 0 0;
`);

const LinksBox = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
    @media ${device.tablet} {

    }
`);

const LogoBox = styled(Box)(({theme}) => `

`);

const Image = styled('img')(({theme}) => `
    height: 32px;
`);

const DescriptionBox = styled(Box)(({theme}) => `
    color: ${theme.palette.white.main};
`);

const SocialMediaBox = styled(Box)(({theme}) => `
    color: ${theme.palette.white.main};
`);

const LinksTitleBox = styled(Box)(({theme}) => `
    color: ${theme.palette.grey.lighten_1};
    display: flex;
    padding: 0px 8px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
`);

const ButtonsBox = styled(Box)(({theme}) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
`);

const ScButton = styled(Button)(({theme}) => `

`);


const CopyrightTitleBox = styled(Box)(({theme}) => `
    color: ${theme.palette.grey.lighten_1};
`);

const ContactTitleBox = styled(Box)(({theme}) => `
    color: ${theme.palette.grey.lighten_1};
`);

const IconAndTextBox = styled(Box)(({theme}) => `
    display: flex;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
`);

const IconBox = styled(Box)(({theme}) => `
    text-align: center;
`);

const IconDescriptionBox = styled(Box)(({theme}) => `
    color: ${theme.palette.white.main};
`);

export default function SimpleFooter (props){
    
    const theme = useTheme();

    const htmlContent_text1 = props['text-1'] && marked(props['text-1']);
    const htmlContent_text2 = props['text-2'] && marked(props['text-2']);
    const htmlContent_text3 = props['text-3'] && marked(props['text-3']);
    const htmlContent_text4 = props['text-4'] && marked(props['text-4']);

    const {page, store, language} = useParams();

    const history = useHistory();

    const [year, setYear] = useState(() => {
        const date = new Date;
        return date.getFullYear();
    })
    
    function handleClick(inputUrl){
        if(inputUrl.substring(0,7) === 'http://'){
            inputUrl = 'https://' + inputUrl.substring(7);
        } else if(inputUrl.substring(0,8) !== 'https://'){
            inputUrl = 'https://' + inputUrl;
        }

        window.open(inputUrl, '_blank', 'noopener,noreferrer');
    }

    function handleNavigation(inputPage){
        history.push(`/page/${inputPage}/${store}/${language}`)
        history.go(0);
    }

    return(

        <Section
            input_color={
                props['color-1'] && props['color-1']
            }
            sx={{
                display: 'flex',
                justifyContent: 'center'
            }}
        >
            <ContentBox>
                <DividerRec />
                <MainBox>
                    <Col1Box>
                        <CompanyAndDescriptionBox>
                            <LogoBox>
                                {   props['images-1'] &&
                                    <Image alt='image' src={props['images-1'][0].thumbnails.large.url} />
                                }
                            </LogoBox>
                            <DescriptionBox>
                                {   props['text-1'] &&
                                    <Typography 
                                        variant='body1'
                                        color='text.on_surface'
                                        dangerouslySetInnerHTML={{ __html: htmlContent_text1 }}
                                    />
                                }
                            </DescriptionBox>
                            <SocialMediaBox>
                                {   props['url-1'] && props['url-1'] !== 'x' && props['url-1'] !== 'X' &&
                                    <IconButton
                                        onClick={() => handleClick(props['url-1'])}
                                        sx={{
                                            color: `${props['color-2'] ? props['color-2'].hex : theme.palette.text.primary}`
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faInstagram} size='lg' /> 
                                    </IconButton>
                                }
                                {   props['url-2'] && props['url-2'] !== 'x' && props['url-2'] !== 'X' &&
                                    <IconButton
                                        onClick={() => handleClick(props['url-2'])}
                                        sx={{
                                            color: `${props['color-2'] ? props['color-2'].hex : theme.palette.text.primary}`
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faFacebook} size='lg' /> 
                                    </IconButton>
                                }
                            </SocialMediaBox>
                        </CompanyAndDescriptionBox>
                        <LinksBox>
                            <LinksTitleBox>
                                {   props['text-2'] &&
                                    <Typography 
                                        variant='body1'
                                        color={theme.palette.text.secondary}
                                        dangerouslySetInnerHTML={{ __html: htmlContent_text2 }}
                                    />
                                }
                            </LinksTitleBox>
                            <ButtonsBox>
                                {   props.pages &&
                                    props.pages?.map( (el, index) => {
                                        return(
                                            <ScButton 
                                                key={index}
                                                onClick={() => handleNavigation(el.url)}
                                                sx={{
                                                    color: `${props['color-2'] ? props['color-2'].hex : theme.palette.text.primary}`
                                                }}
                                            >
                                                <Typography variant='button'>
                                                    {el.name}
                                                </Typography>
                                            </ScButton>
                                        )
                                    } )

                                }
                            </ButtonsBox>
                        </LinksBox>
                    </Col1Box>
                    <ContactBox>
                        {   props['text-3'] &&
                            <ContactTitleBox>
                                <Typography 
                                    variant='body1'
                                    color={theme.palette.text.secondary}
                                    dangerouslySetInnerHTML={{ __html: htmlContent_text3 }}
                                />
                            </ContactTitleBox>
                        }
                        {   props['text-4'] && props['text-4'] !== 'x' && props['text-4'] !== 'X' &&
                            <IconAndTextBox>
                                <IconBox>
                                    <FontAwesomeIcon icon={faLocationPin} size='lg' 
                                        color={props['color-2'] ? props['color-2'].hex : theme.palette.text.primary}
                                    /> 
                                </IconBox>
                                <IconDescriptionBox>
                                    <Typography 
                                        variant='body1'
                                        sx={{
                                            color: `${props['color-2'] ? props['color-2'].hex : theme.palette.text.primary}`
                                        }}
                                        dangerouslySetInnerHTML={{ __html: htmlContent_text4 }}
                                    />
                                </IconDescriptionBox>
                            </IconAndTextBox>
                        }
                        {   props['text-5'] && props['text-5'] !== 'x' && props['text-5'] !== 'X' &&
                            <IconAndTextBox>
                                <IconBox>
                                    <FontAwesomeIcon icon={faEnvelope} size='lg' 
                                        color={props['color-2'] ? props['color-2'].hex : theme.palette.text.primary}
                                    /> 
                                </IconBox>
                                <IconDescriptionBox>
                                    <Typography 
                                        variant='body1'
                                        sx={{
                                            color: `${props['color-2'] ? props['color-2'].hex : theme.palette.text.primary}`
                                        }}
                                        dangerouslySetInnerHTML={{ __html: props['text-5'] }}
                                    />
                                </IconDescriptionBox>
                            </IconAndTextBox>
                        }
                    </ContactBox>
                </MainBox>
                <CopyrightBox>
                    <CopyrightTitleBox>
                        <Typography variant='body1'>
                            © Fong Feng-En Chou copyright {year} all rights reserved
                        </Typography>
                    </CopyrightTitleBox>
                </CopyrightBox>
            </ContentBox>
        </Section>

    )

}